import { Divider, Row, Typography } from "antd";

import { Card } from '@hdi-seguros/web-components.card';
import { ColSize } from "../ColSize";
import { RowSize } from "../RowSize";
import { COLORS } from "../../../config/themes/colors";

interface Span {
    span: number;
}

export interface ColumnSizes {
    xs?: Span;
    sm?: Span;
    md?: Span;
    lg?: Span;
    xl?: Span;
    xxl?: Span;
}
export interface Column {
    label: string, 
    value?: string | JSX.Element, 
    isLikeTitle?: boolean, 
    valueInBold?: boolean,
    columnSize?: ColumnSizes;
}

export const _renderColumns = (columns: Array<Column>) => (
    <>
        { 
            columns?.map(({ label, value = '-', valueInBold = false, isLikeTitle = false, columnSize }, index) => (
                <ColSize size={20} colProps={ columnSize || {md:12} }  key={ `col-${label}-${index}` } >
                    <RowSize>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }} >
                            { label }
                        </Typography.Text>
                    </RowSize>
                    <RowSize>   
                        {   
                             value === 'JSX.Element;' ? (
                                value
                            ) :
                            typeof value === 'string'
                                ? (
                                    <Typography.Text strong={ valueInBold } style={{ fontSize: isLikeTitle ? 20 : 14, wordBreak: 'initial' }} >
                                        { value }
                                    </Typography.Text> 
                                )
                                : <div style={{ marginTop: '0.2rem' }}>{value}</div>
                        }
                    </RowSize>
                </ColSize>
            )) 
        }
    </>
)

export const _renderSection = (title: string = '', key: string = '', columns: Array<Column>, children: any = false, hasDivider = true ) => (
    <>
        <Typography.Title level={ 3 } style={{ margin: 0, marginBottom: 10, color: COLORS.secondary[100] }} id={ key } >
            { title }    
        </Typography.Title>

        <Row style={{ rowGap: 10 }} >
            { _renderColumns( columns ) }
        </Row>
        
        {children && (
            <Row style={{ rowGap: 10 }} >
                { children }
            </Row>
        )}

        {
            hasDivider
                ? <Divider style={{ minWidth: '90%', width: '98%' }} /> 
                : <></>
        }
        
    </>
)

export const _renderCard = (key: string | number, columns: Array<Column>) => (
    <Card title='' style={{ marginTop: '0.5rem', background: COLORS.neutrals[15] }} key={key}>
        <Row gutter={[16, 16]}>
            { _renderColumns( columns ) }
        </Row>
    </Card>
)